import Vue from 'vue';
import multiCascader from 'multi-cascader-base-ele';

Vue.use(multiCascader);
